import { render, staticRenderFns } from "./AssignedRequests.vue?vue&type=template&id=0fbe9a08&scoped=true"
import script from "./AssignedRequests.vue?vue&type=script&lang=js"
export * from "./AssignedRequests.vue?vue&type=script&lang=js"
import style0 from "./AssignedRequests.vue?vue&type=style&index=0&id=0fbe9a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe9a08",
  null
  
)

export default component.exports